(() => {
  if (window.__uniContactLoaded) return;
  window.__uniContactLoaded = true;

  const PREFIX = 'unisystem_';
  const PENDING_KEY = `${PREFIX}contact_pending`;
  const MAX_PENDING_AGE = 30 * 60 * 1000;
  const EVENT_NAMES = { FormStart: 'form_start', FormSubmit: 'form_submit', Lead: 'generate_lead', FormSuccess: 'form_success' };
  const ENGLISH_ENDPOINT = 'https://n8n.srv1093230.hstgr.cloud/webhook/unisystem-ingles-lead-v1-7e4c9a2b';
  const getStored = (key) => { try { return sessionStorage.getItem(key) || ''; } catch { return ''; } };
  const setStored = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const removeStored = (key) => { try { sessionStorage.removeItem(key); } catch {} };
  const identifier = () => window.UniAnalytics?.identifier() || window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
  const safePath = (value) => {
    try { const url = new URL(value, location.origin); return `${url.origin}${url.pathname}`; } catch { return ''; }
  };
  const safePublicId = (value) => /^[a-zA-Z0-9:_-]{1,100}$/.test(value || '') ? value : '';
  const readPending = () => {
    try {
      const value = JSON.parse(getStored(PENDING_KEY));
      if (!value || !value.eventId || !value.submissionId || !value.createdAt) return null;
      if (Date.now() - value.createdAt > MAX_PENDING_AGE || value.createdAt > Date.now() + 10000) { removeStored(PENDING_KEY); return null; }
      return value;
    } catch { return null; }
  };
  const publish = (name, details, eventId, channelLimit) => {
    if (EVENT_NAMES[name]) window.UniAnalytics?.track(EVENT_NAMES[name], details, eventId, channelLimit);
  };
  const setField = (form, name, value) => {
    let field = form.elements.namedItem(name);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value || '';
  };

  function initialize(root = document) {
    root.querySelectorAll('[data-uni-contact]').forEach((section) => {
      const form = section.querySelector('[data-uni-contact-form]');
      if (!form || form.dataset.uniBound === 'true') return;
      form.dataset.uniBound = 'true';
      const mode = section.dataset.mode === 'english' ? 'english' : 'institutional';
      const purpose = section.dataset.purpose === 'general' ? 'general' : 'admissions';
      const formId = mode === 'english' ? 'english_interest' : 'institutional_interest';
      const source = mode === 'english' ? 'landing_ingles' : 'sitio_institucional';
      const variant = mode === 'english' ? 'unisystem-glass-v1' : 'unisystem-institutional-v1';
      const params = new URLSearchParams(location.search);
      const pageViewAt = new Date().toISOString();
      const button = form.querySelector('[data-contact-submit]');
      const error = form.querySelector('[data-contact-error]');
      const success = form.querySelector('[data-contact-success]');
      const fields = form.querySelector('[data-contact-fields]');
      const sendingStatus = form.querySelector('[data-contact-sending]');
      const startedField = form.querySelector('[data-form-started-at]');
      const programSelect = form.querySelector('[data-contact-program]');
      const inquiry = form.querySelector('[data-english-inquiry]');
      const showConfirmationSummary = (programId, context) => {
        const summary = form.querySelector('[data-contact-success-summary]');
        if (!summary || mode !== 'institutional' || purpose !== 'admissions') return;
        let offer;
        try { offer = JSON.parse(document.getElementById('uni-offer-config')?.textContent || '{}'); } catch { return; }
        if (!offer.programs?.[programId] || !['distancia', 'presencial'].includes(context?.modalidad) || context.periodo !== offer.period) return;
        const program = summary.querySelector('[data-contact-success-program]');
        const modality = summary.querySelector('[data-contact-success-modality]');
        const period = summary.querySelector('[data-contact-success-period]');
        if (!program || !modality || !period) return;
        program.textContent = offer.programs[programId];
        modality.textContent = offer.label?.[context.modalidad] || context.modalidad;
        period.textContent = context.periodo;
        summary.hidden = false;
      };
      const showConfirmationLayout = () => {
        if (mode !== 'institutional') return;
        section.dataset.contactView = 'success';
        const title = success?.querySelector('[data-contact-confirmed-copy][id]');
        if (title) section.setAttribute('aria-labelledby', title.id);
      };
      if (section.dataset.contactPreview === 'true' && window.Shopify?.designMode) {
        form.dataset.contactState = 'preview';
        showConfirmationLayout();
        let offer;
        try { offer = JSON.parse(document.getElementById('uni-offer-config')?.textContent || '{}'); } catch {}
        showConfirmationSummary(section.dataset.programId, { modalidad: 'distancia', periodo: offer?.period });
        if (success) success.hidden = false;
        if (fields) fields.hidden = true;
        form.addEventListener('submit', event => event.preventDefault());
        return;
      }
      if (mode === 'english' && inquiry) {
        const message = form.elements.namedItem('contact[body]');
        const originalMessage = message.defaultValue;
        const note = form.querySelector('[data-toefl-note]');
        const syncInquiry = () => {
          const isToefl = inquiry.value === 'toefl';
          note.hidden = !isToefl;
          message.value = isToefl ? `${inquiry.selectedOptions[0].textContent.trim()}. ${note.textContent.trim()}` : originalMessage;
          section.querySelectorAll('[data-english-cool-intro],.uni-contact__support,.uni-contact__virtual').forEach(element => { element.hidden = isToefl; });
          const intro = section.querySelector('[data-english-toefl-intro]');
          if (intro) intro.hidden = !isToefl;
          if (isToefl) inquiry.setAttribute('aria-describedby', note.id);
          else inquiry.removeAttribute('aria-describedby');
        };
        const selectInquiry = value => { inquiry.value = value; inquiry.dispatchEvent(new Event('change', { bubbles: true })); };
        inquiry.addEventListener('change', syncInquiry);
        document.addEventListener('click', event => {
          const link = event.target.closest('a[href="#consulta-toefl"],a[href="#solicitar-informacion"]');
          if (!link || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.button > 0) return;
          const isToefl = link.getAttribute('href') === '#consulta-toefl';
          selectInquiry(isToefl ? 'toefl' : 'cool');
          if (isToefl) requestAnimationFrame(() => inquiry.focus({ preventScroll: true }));
        });
        form.addEventListener('reset', () => requestAnimationFrame(syncInquiry));
        if (location.hash === '#consulta-toefl') inquiry.value = 'toefl';
        syncInquiry();
      }
      let formStarted = false;
      let submitting = false;
      let captchaContinuation = false;
      if (startedField) startedField.value = String(Date.now());

      const updateProgram = () => {
        if (mode === 'institutional' && purpose === 'general') return '';
        const selected = programSelect?.selectedOptions?.[0];
        const publicId = selected?.dataset.programId || section.dataset.programId || (mode === 'english' ? 'ingles-cool' : '');
        if (mode !== 'english') setField(form, 'contact[programa_id]', publicId);
        return safePublicId(publicId);
      };
      if (programSelect) {
        const requestedProgram = params.get('programa');
        const requestedOption = Array.from(programSelect.options || []).find((option) => option.dataset.programId === requestedProgram);
        if (requestedOption) programSelect.value = requestedOption.value;
        programSelect.addEventListener('change', updateProgram);
        updateProgram();
      }
      const offerContext = () => {
        let offer;
        try { offer = JSON.parse(document.getElementById('uni-offer-config')?.textContent || '{}'); } catch { return {}; }
        const programId = updateProgram();
        if (mode !== 'institutional' || purpose !== 'admissions' || !offer.programs?.[programId]) return {};
        const selected = form.querySelector('[data-contact-modality]')?.value || params.get('modalidad');
        return { modalidad: offer.distanceOnly?.includes(programId) ? 'distancia' : (selected === 'presencial' ? 'presencial' : 'distancia'), periodo: offer.period };
      };
      const attribution = () => window.UniAnalytics?.leadAttribution() || {};
      const eventDetails = () => ({ form_id: formId, form_purpose: purpose, programa_id: updateProgram(), landing_variant: variant, lead_source: source, cta_location: 'form', section_id: section.id, ...offerContext() });
      const resetSubmitting = () => {
        submitting = false;
        captchaContinuation = false;
        if (!['confirmed', 'returned'].includes(form.dataset.contactState)) form.dataset.contactState = 'idle';
        if (sendingStatus) sendingStatus.hidden = true;
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = button.dataset.idleLabel || button.textContent;
        }
      };
      window.addEventListener('pageshow', resetSubmitting);

      form.addEventListener('focusin', (event) => {
        if (formStarted || !event.target.matches('input:not([type="hidden"]), select, textarea')) return;
        formStarted = true;
        publish('FormStart', eventDetails());
      });

      form.addEventListener('submit', (event) => {
        if (form.elements.namedItem('company_website')?.value || !form.checkValidity()) {
          event.preventDefault();
          if (error) { error.hidden = false; error.focus(); }
          return;
        }
        if (submitting) {
          const captchaResponse = form.elements.namedItem('h-captcha-response')?.value;
          if (captchaResponse && !captchaContinuation) { captchaContinuation = true; return; }
          event.preventDefault();
          return;
        }
        if (error) error.hidden = true;
        const oldPending = readPending();
        const sameRequest = oldPending?.path === location.pathname && oldPending?.mode === mode && oldPending?.formDomId === form.id;
        const pending = sameRequest ? oldPending : { eventId: identifier(), submissionId: identifier(), createdAt: Date.now(), mode, path: location.pathname, formDomId: form.id };
        pending.programId = updateProgram();
        pending.offer = offerContext();
        pending.sessionId ||= identifier();
        pending.leadId ||= identifier();
        pending.trackingConsent = {
          analytics: window.UniAnalytics?.permission('analytics') === true,
          marketing: window.UniAnalytics?.permission('marketing') === true
        };
        const values = {
          ...attribution(),
          ...pending.offer,
          session_id: pending.sessionId,
          lead_id: pending.leadId,
          landing_variant: variant,
          lead_source: source,
          landing_url: safePath(location.href),
          page_view_at: pageViewAt,
          environment: 'shopify_storefront',
          event_id: pending.eventId,
          submission_id: pending.submissionId,
          consent_text_version: section.dataset.consentVersion || '2026-09-15-v1',
          consent_at_client: new Date().toISOString()
        };
        Object.entries(values).forEach(([key, value]) => setField(form, `contact[${key}]`, value));
        updateProgram();
        const returnUrl = new URL(location.pathname, location.origin);
        const previewTheme = params.get('preview_theme_id');
        if (/^\d+$/.test(previewTheme || '')) returnUrl.searchParams.set('preview_theme_id', previewTheme);
        returnUrl.hash = 'solicitar-informacion';
        if (mode === 'english') {
          if (section.dataset.leadEndpoint !== ENGLISH_ENDPOINT) {
            event.preventDefault();
            if (error) { error.hidden = false; error.focus(); }
            return;
          }
          setField(form, 'return_url', returnUrl.toString());
          form.action = ENGLISH_ENDPOINT;
        } else {
          if (pending.offer?.periodo) {
            returnUrl.searchParams.set('programa', pending.programId);
            returnUrl.searchParams.set('modalidad', pending.offer.modalidad);
            returnUrl.searchParams.set('periodo', pending.offer.periodo);
          }
          returnUrl.searchParams.set('contact_posted', 'true');
          returnUrl.searchParams.set('contact_form', form.id);
          setField(form, 'return_to', `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`);
        }
        removeStored(`${PREFIX}pqr_pending`);
        setStored(PENDING_KEY, JSON.stringify(pending));
        setStored(`${PREFIX}pending_form_event_id`, pending.eventId);
        setStored(`${PREFIX}pending_submission_id`, pending.submissionId);
        submitting = true;
        form.dataset.contactState = 'submitting';
        if (sendingStatus) sendingStatus.hidden = false;
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.textContent = button.dataset.busyLabel || button.textContent;
        }
        publish('FormSubmit', { ...eventDetails(), submission_id: pending.submissionId }, pending.eventId);
        window.setTimeout(resetSubmitting, 20000);
      });

      const pending = readPending();
      const matchingPending = pending?.mode === mode && pending?.path === location.pathname && pending?.formDomId === form.id;
      let pqrPending = null;
      try { pqrPending = JSON.parse(getStored(`${PREFIX}pqr_pending`)); } catch {}
      const pqrReturn = pqrPending?.path === location.pathname && Date.now() - pqrPending.createdAt < MAX_PENDING_AGE;
      const returnFormId = params.get('contact_form') || (pqrReturn ? pqrPending.formId : '');
      const belongsToForm = !returnFormId || returnFormId === form.id;
      const serverMarker = success?.dataset.serverConfirmed === 'true' && belongsToForm;
      const serverConfirmed = serverMarker && (mode === 'english' || matchingPending);
      if (serverMarker && !serverConfirmed) { if (success) success.hidden = true; if (fields) fields.hidden = false; }
      if (!belongsToForm) {
        if (success) success.hidden = true;
        if (fields) fields.hidden = false;
        form.querySelectorAll('[data-server-error]').forEach((node) => { node.hidden = true; });
      }
      const englishReturned = mode === 'english' && params.get('lead_success') === '1' && matchingPending;
      if (serverConfirmed || englishReturned) {
        form.dataset.contactState = serverConfirmed ? 'confirmed' : 'returned';
        if (englishReturned && !serverConfirmed) {
          form.querySelectorAll?.('[data-contact-confirmed-copy]').forEach((node) => { node.hidden = true; });
          form.querySelectorAll?.('[data-contact-returned-copy]').forEach((node) => { node.hidden = false; });
        }
        if (serverConfirmed) {
          showConfirmationSummary(pending?.programId, pending?.offer);
          showConfirmationLayout();
        }
        if (success) { success.hidden = false; requestAnimationFrame(() => success.focus()); }
        if (fields) fields.hidden = true;
        if (matchingPending) {
          if (serverConfirmed) {
            const details = { ...eventDetails(), programa_id: pending.programId, submission_id: pending.submissionId, ...pending.offer };
            const channelLimit = { analytics: pending.trackingConsent?.analytics === true, marketing: pending.trackingConsent?.marketing === true };
            if (channelLimit.analytics || channelLimit.marketing) {
              window.UniAnalytics?.whenPrivacyReady?.(available => {
                if (!available) return;
                publish('FormSuccess', details, pending.eventId, channelLimit);
                if (purpose === 'admissions') publish('Lead', details, pending.eventId, channelLimit);
              });
            }
          }
          removeStored(PENDING_KEY);
          removeStored(`${PREFIX}pending_form_event_id`);
          removeStored(`${PREFIX}pending_submission_id`);
        }
        if (englishReturned) {
          const cleanUrl = new URL(location.href);
          cleanUrl.searchParams.delete('lead_success');
          history.replaceState({}, document.title, `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
        }
      }
      const serverError = form.querySelector('[data-server-error]');
      if (serverError && belongsToForm) requestAnimationFrame(() => serverError.focus());
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

